export default class InfoNCVVN{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-ncvvn');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/lineage2mncv/footer-rating-vn.png">
        </div>
        <div class="footer-info-address">
CÔNG TY TNHH TRUYỀN THÔNG MINH PHƯƠNG THỊNH<br>
Địa chỉ trụ sở: 229 Huỳnh Ngọc Huệ, Phường Thanh Khê Đông, Quận Thanh Khê, Thành phố Đà Nẵng, Việt Nam.<br>
Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng số 48/GP-PTTH&TTĐT do Cục Phát thanh, truyền hình và thông tin điện tử cấp ngày 27/02/2025.<br>
Quyết định phát hành trò chơi điện tử G1 trên mạng số 183/QĐ-PTTH&TTĐT do Cục Phát thanh, truyền hình và thông tin điện tử cấp ngày 16/05/2025.<br>
Số điện thoại: 1900 561 558
        </div>
        `;
    }
}
